import {Modal, Button, Form, Table} from 'react-bootstrap';
import {useState, useMemo} from 'react';
import API from '../helpers/api.js';
import {useDispatch} from 'react-redux';
import moment from 'moment'
export default function IapLookupModal({close}){
    const dispatch = useDispatch();
    const api = useMemo(() => new API({dispatch}), [dispatch]);
    const [orderId, setOrderId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [results, setResults] = useState(null);

    const lookupOrder = async () => {
        setLoading(true);
        setError(null);
        setResults(null);
        try {
            const data = await api.lookupIAPOrder(orderId);
            setResults(data.result);

            if (!data.result || data.result.length === 0) {
                setError('No transactions found for this Order ID.');
            }
        } catch(err){
            setError('Error looking up order. Please check the Order ID and try again.');
        } finally {
            setLoading(false);
        }
    }

    const buildResultsSection = () => {
        if (loading) return null;
        if (error) return null;
        
        if (!results || results.length === 0) return <div className="mt-3">No transactions found for this Order ID.</div>;

        return (
            <Table striped bordered hover className="mt-3">
                <thead>
                    <tr>
                        <th>Transaction ID</th>
                        <th>Product ID</th>
                        <th>Expiration Date</th>
                        <th>Amount</th>
                        <th>Transaction Reason</th>
                        <th>Transaction Date</th>
                    </tr>
                </thead>
                <tbody>
                    {results.map(tx => (
                        <tr key={tx.transactionId}>
                            <td>{tx.transactionId}</td>
                            <td>{tx.productId}</td>
                            <td>{moment(tx.expirationDate).format('MMMM Do YYYY, h:mm:ss a')}</td>
                            <td>{tx.price / 100}</td>
                            <td>{tx.transactionReason}</td>
                            <td>{moment(tx.purchaseDate).format('MMMM Do YYYY, h:mm:ss a')}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        );
    }

    return (
        <Modal show onHide={close} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Lookup IAP Order</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Order ID</Form.Label>
                        <Form.Control type="text" value={orderId} onChange={e => setOrderId(e.target.value)} placeholder="Enter IAP Order ID" />
                    </Form.Group>
                    <Button variant="primary" onClick={lookupOrder} disabled={loading || !orderId}>
                        {loading ? 'Looking up...' : 'Lookup Order'}
                    </Button>
                </Form>
                {error && <div className="mt-3 text-danger">{error}</div>}
                {buildResultsSection()}
            </Modal.Body>
        </Modal>
    )
}